<template>
  <section v-if="modal" class="img-content">
    <article v-for="(image, index) in images" :key="image.id">
      <img
        :alt="image.name"
        :src="
          image.type === 0
            ? image.thumbnails.s_cd ||
              require('@/assets/images/placeholder-gallery.svg')
            : getVideoImagePreview(image.video_url)
        "
        class="cursor-pointer image-modal"
        :class="{
          'event-img': type === 'events'
        }"
        loading="lazy"
        @click="
          openPreviewModal(IMAGE_PREVIEW, {
            index: index,
            title: image.name,
            images: images
          })
        "
      />
    </article>
  </section>

  <carousel
    v-else
    :breakpoints="breakpoints"
    :transition="500"
    :wrap-around="false"
    class="carousel fixed-carousel-arrows relative"
  >
    <slide
      v-for="(image, index) in images"
      :key="image.id"
      :aria-hidden="false"
    >
      <img
        :alt="image.name"
        :src="
          image.type === 0
            ? image.thumbnails.s_cd ||
              require('@/assets/images/placeholder-gallery.svg')
            : getVideoImagePreview(image.video_url)
        "
        class="cursor-pointer image-gallery"
        :class="{
          'xs:ml-0 ml-[0.813rem]': index === 0,
          'event-img': type === 'events'
        }"
        loading="lazy"
        @click="
          openPreviewModal(IMAGE_PREVIEW, {
            index: index,
            title: image.name,
            images: images
          })
        "
      />
    </slide>
  </carousel>
</template>

<script setup>
import { computed } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import { useModalHandler } from "@/plugins/useModalHandler";
import { BREAKPOINTS } from "@/constants.js";

const props = defineProps({
  images: {
    type: Array,
    default: undefined
  },
  navigation: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: "events"
  },
  modal: {
    type: Boolean,
    default: false
  }
});
const { IMAGE_PREVIEW, openPreviewModal } = useModalHandler();
const getVideoImagePreview = url => {
  let id = url?.match(/embed\/([A-Za-z0-9-_]{11})/);
  if (!id?.length) return;
  id = id[0].replace("embed/", "");
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
};
const breakpoints = computed(() => {
  if (props.type === "events") {
    return BREAKPOINTS.galleryImages;
  } else if (props.type === "artists") {
    return BREAKPOINTS.galleryArtistImages;
  } else {
    return BREAKPOINTS.images;
  }
});
</script>

<style lang="scss" scoped>
.image-gallery {
  height: 112px;
  width: 160px;
  object-fit: cover;
  border-radius: 6px;
  @media screen and (min-width: $screen-lg) {
    height: 293px;
    width: 284px;
    &.events-img {
      height: 273px;
    }
  }
}
.img-content {
  display: grid;
  grid-auto-rows: auto;
  gap: 10px;
  grid-template-columns: repeat(3, minmax(101px, 1fr));
  @media screen and (min-width: $screen-lg) {
    grid-template-columns: repeat(5, minmax(171px, 1fr));
  }
}
.image-modal {
  // height: 101px;
  // width: 101px;
  aspect-ratio: 1/1;
  object-fit: cover;
  @media screen and (min-width: $screen-lg) {
    height: 171px;
    width: 171px;
    &.events-img {
      height: 273px;
    }
  }
}
</style>
